import { PageType } from "../../../constants/types.constants";
import { FuturePageDetailsEntity } from "../entities/future-page-details.entity";

export interface IFuturePageDetailsModel {
  id: number;
  pageYear: number;
  imageName: string;
  description: string;
  type: PageType;
  createdAt: string;
  updatedAt: string;
  imageUrl: string;
}

export class FuturePageDetailsModel {
  id: number;
  pageYear: number;
  imageName: string;
  description: string;
  type: PageType;
  createdAt: string;
  updatedAt: string;
  imageUrl: string;

  constructor(data: IFuturePageDetailsModel) {
    this.id = data.id;
    this.pageYear = data.pageYear;
    this.imageName = data.imageName;
    this.description = data.description;
    this.type = data.type;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.imageUrl = data.imageUrl;
  }

  toEntity(): FuturePageDetailsEntity {
    return {
      id: this.id,
      pageYear: this.pageYear.toString(),
      imageName: this.imageName,
      description: this.description,
      type: this.type,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      imageUrl: this.imageUrl,
    };
  }
}
